import { render, staticRenderFns } from "./game-banner.vue?vue&type=template&id=f21a3862"
import script from "./game-banner.vue?vue&type=script&lang=js"
export * from "./game-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/game-banners/game-banner.vue
// module id = CGFq
// module chunks = 0